import { Injectable } from "@angular/core";
import { HttpService } from "../../utils/services/http.service";
import { Observable } from "rxjs/Observable";
import { ErrorsService } from "../../utils/services/errors.service";

@Injectable()
export class ProjectService {
  constructor(
    private httpService: HttpService,
    private errorsService: ErrorsService
  ) {}

  /** Function to get project list*/
  getProjectList(pagenumber): Observable<any> {
    const data = { pageSize: 7, pageNumber: pagenumber };
    return this.httpService
      .post(`project/listFilter`, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /** Function to update project list*/
  updateProject(data) {
    return this.httpService
      .put(`project`, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /** Function to search project*/
  searchFilter(searchTerm: string): Observable<any> {
    const data = { searchText: searchTerm };
    return this.httpService
      .post(`project/search`, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /** Function to delete project*/
  deleteProject(data: any): Observable<any> {
    return this.httpService
      .put(`deleteProject`, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
    // // return this.httpService
    // //   .delete(
    // //     `project/${project}/${data.userObj.Empname}/${data.userObj.EmailID}`
    // //   )
    // //   .map((res: Response) => res.json())
    // //   .catch((error: any) => {
    // //     return this.handleError(error);
    //   });
  }

  /** Function to upload Export File data*/
  getXslData(url, data: any): Observable<any> {
    return this.httpService
      .post(url, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /** Function to handle error service*/
  handleError(error: any) {
    this.errorsService.handleError(error);
    return Observable.throw(error.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/project/project.service.ts